<template>
  <div class='h-dialogContainer h-alarm-filter'>
      <div class='col-sm-12'>
         <progress-bar v-show='showProgressBar' ref='progressBar' :val='progressVal' :text='progressText' class="upload-progress"></progress-bar>
      </div>
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div id='treeContainer' class='h-col-inputBox'>
            <div class='h-borderBox h-filterTopoTree height-320'>
              <BackupGnbTopoTree v-show='showTree' @pmGnbTopoTreeClickEventPush="pmGnbTopoTreeClickEventPush" ref='pmGnbTopoTreeRef' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true' graphType="2"></BackupGnbTopoTree>
            </div>
          </div>
        </div>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
                <div class="upload-btn" id="batchUploadBtnDiv">
                      <ejs-button class="e-input" isPrimary='true' @click.native='batchUpButton' >{{$t("MML.upload")}}</ejs-button>
                </div>
          </div>
              <div class='h-system-hide-upload'>
                <ejs-uploader ref='batchFile' name='batchFile' id='batchFile' autoUpload='false' :selected='onFileSelects'

                              :multiple='false'></ejs-uploader>
              </div>
        </div>
        <div class='h-clear-rowMg'></div>
      </div>
  </div>
</template>

<script>
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";
  import { EventBus } from '../../../../../plugins/eventBus';
  import BackupGnbTopoTree from "../tree/BackupGnbTopoTree";
  import mmlSocket from '@/plugins/stompSock';
  import packageParams from '@/components/mmlconfig/mixins/packageParams';
  import ProgressBar from 'vue-simple-progress';

  export default {
    name: 'BackupRecoverDialog',
    components: {
      BackupGnbTopoTree,
      ProgressBar
    },
    mixins: [packageParams],
    data() {
      return {
        dateFormat: 'yyyy-MM-dd',
        periodicUploadTime: '',
        alias: '',
        showTree: true,
        showProgressBar: false,
        progressVal: 0,
        progressText: '0%',
        locale: localStorage.getItem('locale'),
        neClickInfo: null,
        addGnbTaskValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            periodicUploadTime: {
              required: [true, this.$t('MML.selBaseTime')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('MML.timeFormatError')]
            },
            alias: {
              required: [true, this.$t('fillAlias')],
            }
          }
        },
        formObjOfAddGnbTaskDialog: '',
        payload: [
          { topic: '/user/#/MMLServer', clientId: this.getUserId(), callback: this.mmlWebsocketLisener }
        ],
      }
    },
    methods: {
      batchUpButton() {
        console.log("select____________________")
        console.log(this.neclickInfo)
        console.log(!this.neClickInfo);
        if(!this.neClickInfo){
           this.eventEmit('warning', this.$t('MML.selOneBase'));
           return;
        }
        const fileDoms = document.getElementsByClassName('e-file-select-wrap');
        for(var i =0;i<fileDoms.length;i++){
           let item = fileDoms[i];
           if(item.querySelector('input').id == 'batchFile'){
              item.querySelector('button').click();
           }
        }



       // document
       //   .getElementsByClassName('e-file-select-wrap')[1]
       //   .querySelector('button')
       //   .click();
        return false;
      },
      async onFileSelects(args) {
        this.tryUtilFileLoaded();
      },
      tryUtilFileLoaded(){
        setTimeout(() => {
          try {
            const uploadPrefix = this.randomId();
            this.bigFileUpload(uploadPrefix);
          } catch (error) {
            this.tryUtilFileLoaded();
          }
        }, 100);
      },
      randomId() {
        const _temp = 'abcdefghijklmnopqrstuvwxyz';
        let randStr = '';
        for (let i = 0; i <= 8; i++) {
          randStr += _temp[Math.round(Math.random(1) * 26)];
        }
        return randStr;
      },
      getParam() {
        // const index = this.$refs.versionList.ej2Instances.index;
        // const version = this.versionSource[index];
        let type = 0;
        // const radioGroup = document.getElementsByName('DeliverRadio');
        // radioGroup.forEach(item => {
        //   if(item.checked) {
        //   type = item.ej2_instances[0].value;
        //   }
        // });
        const file = this.$refs.batchFile.ej2Instances.filesData[0];
        const param = {
          // version: version,
          file: file['rawFile'],
          fileType:file['type'],
          type: type
        };
        return param;
      },
      async bigFileUpload(uploadPrefix) {
        // 进度条
        this.brokenFlag = 0;
        const data = this.getParam();
        const srcFile = data['file'];
        // 如果文件为空，则退出
        if(!srcFile){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
          return null;
        }
       // if(data['fileType'] != 'gz' && data['fileType'] != 'zip' && data['fileType'] != 'pkg'){
       //  this.eventEmit('warning', this.$t('DeployManagement.invalidPackage'));
       //   return;
       // }
        /*if(srcFile.name.lastIndexOf(".lnk") != -1 || srcFile.name.lastIndexOf(".url") != -1){
          this.eventEmit('warning', this.$t('DeployManagement.invalidPackage'));
          return;
        }*/
        // 检查该文件是否上传过
        /*const isExist = await this.checkExistPackage();
        if (isExist) {
          this.eventEmit('warning', this.$t('DeployManagement.pkgExists'));
          return;
        }*/
        document.getElementById("batchUploadBtnDiv").style.display="none";
        document.getElementById("treeContainer").style.display="none";
        this.showTree = false;
        this.showProgressBar = true;
        EventBus.$emit("setChildProps", {status:0});
        const tempFiles = [];
        // 每片5M
        const perPiece = 1024 * 1024 * 50;
        let originalFilePath = '';
        let start = 0;
        let end = 0;
        let index = 0;
        let totalPieces = 0;
        let filesize = srcFile.size;
        let filename = srcFile.name;
        // 计算文件切片总数
        totalPieces = filesize % perPiece == 0 ? filesize/perPiece : filesize/perPiece + 1;
        // 上传文件
        const url = '/lte/ems/config/mml/bigFilePiece';
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          processData: false,
          async: false,
          contentType: false
        };
        let pecent = 0;
        this.showProgressBar = true;
        while((start < filesize) && this.brokenFlag == 0) {
          // 切片上传
          end = start + perPiece;
          if(end > filesize) {
            // 一次性上传
            end = filesize;
          }
          // 分割文件核心部分slice
          const chunk = srcFile.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk, filename);
          formData.append("totalPieces", totalPieces);
          formData.append("index", index);
          formData.append("process", pecent);
          formData.append("prefix", uploadPrefix);
          await this.$axios.post(url, formData, config).then(response => {
            const result = response['data']['resultVal'];
            tempFiles.push(result['msg']);
            originalFilePath = result['message'];
            // // 进度条
            pecent=((100*(end)/filesize)/4).toFixed(2);
            if(pecent>=100){
              pecent=100.00;
            }
            this.progressVal = pecent;
            this.progressText = pecent + '%';
          });
          start = end;
          index ++;
        }
        if(this.brokenFlag == 0){
          this.mergeBigFile(tempFiles, originalFilePath, uploadPrefix, filename);
        }else{
          this.clearCancelTempFile(uploadPrefix);
        }
      },
      clearCancelTempFile(prefix){
        const url = '/lte/ems/config/mml/clearCancelTempFile';
        const param = {
          prefix: prefix
        };
        this.$axios.post(url, param).then(res => {
          console.log("clear cancel tempFile...");
        });
      },
      mergeBigFile(tempFiles, originalFilePath, taskId, filename) {
        const url = '/lte/ems/config/mml/mergeBigFile';
        const param = {
          tempFiles: tempFiles,
          originalFilePath: originalFilePath,
          userId:this.getUserId()
        };
        this.progressText = this.$t('DeployManagement.mergeBigFile');
        this.$axios.post(url, param).then(res=> {
          if(res.data.errorCode == 'SUCCESS'){
            const data = this.getParam();
            console.log("data file.....", data);
            if(data['file']['name'].indexOf("eMS_NeAdapter_") > -1 || data['fileType'] == "pkg"){
              this.progressText = this.$t('System.processing');
              this.sendUpload(originalFilePath);
            }else{
              this.progressText = this.$t('DeployManagement.uploading');
              this.sendUpload(originalFilePath, taskId, filename);
            }
          }else{
            this.progressText = res.data.errorString;
          }
          EventBus.$emit("setChildProps", {status:1});
        });

      },
      sendUpload(originalFilePath, taskId, filename){
        const url = '/lte/ems/config/mml/uploadPackage';
        const param = {
          filePath: originalFilePath,
          taskId:taskId,
          isBatch: true,
          currentNeIds: this.neClickInfo,
          channelId: this.getUserId()
        };
        let fileUrl = '';
        this.$axios.post(url, param, {timeout: 60 * 5 * 1000}).then(res => {
          if(res.data.errorCode == 'SUCCESS'){
            this.progressVal = 50;
            this.progressText = 50 + '%';
            ////this.progressText = this.$t('DeployManagement.uploadFinish');
            fileUrl = res.data.resultVal.url;
            console.log("fileUrl:"+fileUrl)

            const deviceSyncCfgUrl = '/lte/ems/config/mml/deviceASyncCfgRequest';
            const deviceSyncCfgParam = {
              url: fileUrl
              //equipmentId: this.currentNe.id
            };
           this.$axios.post(deviceSyncCfgUrl, deviceSyncCfgParam, {timeout: 60 * 5 * 1000}).then(res => {
              console.log(res.data)
              if(res.data.errorCode == 'SUCCESS'){
                 this.progressVal = 75;
                 this.progressText = 75 + '%';
              }else{
                 this.progressVal = 75;
                 this.progressText = 75 + '%';
              }
           });
          }else{
            this.progressText = res.data.errorString;
            return;
          }
        });
      },
      bindValidateOfAddGnbTaskDialog(){
        this.formObjOfAddGnbTaskDialog = new FormValidator('#addGnbTaskDialog', this.addGnbTaskValidation);
      },

      validateOfAddGnbTaskDialog() {
        const formStatus = this.formObjOfAddGnbTaskDialog.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },

      pmGnbTopoTreeClickEventPush(params) {
        console.log(params)
        this.neClickInfo = {};
        this.neClickInfo = params;
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
      mmlWebsocketLisener(wsMessage) {
          console.log("mmlWebsocketLisener",wsMessage);
          const message = JSON.parse(wsMessage.body);
          console.log("dialog_message: "+ message.data);
          if( '3' == message.cmd){
            this.progressVal = 100;
            this.progressText = this.$t('MML.exeTimeOut');
          }
          if( '2' == message.cmd ){
            this.progressVal += message.data;
            this.progressText = this.progressVal+'%';
          }
          if( '5' == message.cmd ){
            this.progressVal = 100;
            this.progressText = this.$t('MML.exeSuccess');
          }
        }
    },
    beforeDestroy(){
      mmlSocket.stopReceiveTopicMsg(this.getUserId(), '/user/#/MMLServer');
    },
    mounted() {
      //this.bindValidateOfAddGnbTaskDialog();
      mmlSocket.init(this.payload);
    }
  }
</script>

<style scoped>
</style>
